import ActionCable from 'actioncable'

class Websocket {
  static initStore(store) {
    Websocket.store = store
    Websocket.consumer = ActionCable.createConsumer()
    // The server identifies the socket by the session cookie it opened with (#31836).
    // A logout and re-login as someone else without a page reload keeps that socket,
    // so reopen it; the reopened socket re-sends every subscription. `sync` reopens
    // before any component re-subscribes for the new user.
    let lastUserId = null
    store.watch(
      state => state.user?.id,
      userId => {
        if (!userId) return
        if (lastUserId && String(lastUserId) !== String(userId)) {
          Websocket.consumer.connection.reopen()
        }
        lastUserId = userId
      },
      { sync: true }
    )
  }

  static unsubscribe(subscription) {
    if (subscription) {
      return Websocket.consumer.subscriptions.remove(subscription)
    }
  }

  static subscribe(channel, handler, params = {}) {
    return Websocket.consumer.subscriptions.create(
      { channel, ...params },
      { received: res => handler(res.event, res.data, Websocket.store) }
    )
  }

  static subscribeToApplicationChannel(handler) {
    return Websocket.subscribe('ApplicationChannel', handler)
  }

  static subscribeToNotificationsChannel(handler, userId) {
    return Websocket.subscribe('NotificationsChannel', handler, {
      user_id: userId,
    })
  }

  static subscribeToInquiryChannel(handler) {
    const tenantId = Websocket.store.state?.user?.tenant_id
    if (tenantId) {
      return Websocket.subscribe('InquiryChannel', handler, {
        tenant_id: tenantId,
      })
    }
  }
}

export default Websocket
